import { useCallback } from "react";
import { postcodeIo } from "lib/api/postcodeIo";

/**
 * Hook that provides a best-effort postcode coordinate lookup.
 * Returns coordinates if found, null otherwise — never blocks or shows errors.
 */
export const usePostcodeValidation = () => {
  const getPostcodeCoordinates = useCallback(
    async (postcode: string): Promise<{ lat: number; lng: number } | null> => {
      if (!postcode) return null;

      try {
        const { latitude, longitude } = await postcodeIo.getCoordinates(
          postcode,
        );
        return { lat: latitude, lng: longitude };
      } catch {
        return null;
      }
    },
    [],
  );

  return { getPostcodeCoordinates };
};
